import { Contacts } from './contacts.model';
import { Files } from './file.model';
import { Notes } from './notes.model';

export class Registrations {
    id: string;
    dateSubmitted: Date;
    company: string;
    firstName: string;
    lastName: string;
    title: string;
    email: string;
    primaryUseCase: string;
    description: string;
    license: string;
    instanceId: string;
    eulaAccepted: boolean;
    contacts: Contacts[];
    notes: Notes[];
    files: Files[];

    constructor() {
        this.id = '';
        this.dateSubmitted = null;
        this.company = '';
        this.firstName = '';
        this.lastName = '';
        this.title = '';
        this.email = '';
        this.primaryUseCase = '';
        this.description = '';
        this.license = '';
        this.instanceId = '';
        this.eulaAccepted = true;
        this.contacts = [];
        this.notes = [];
        this.files = [];
    }
}